import config from 'config';
import * as actionTypes from './actions';
export const initialState = {
    executiveTeam: [],
    reload: true,
    updateData: [],
    addNewStatus: false,
    currentPage: 'change-details'
};
const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setExecutiveTeam:
            return {
                ...state,
                executiveTeam: action.executiveTeam
            };
        case actionTypes.setReload:
            return {
                ...state,
                reload: action.reload
            };
        case actionTypes.setUpdateData:
            return {
                ...state,
                updateData: action.updateData
            };
        case actionTypes.setAddNewStatus:
            return {
                ...state,
                addNewStatus: action.addNewStatus
            };
        case actionTypes.setCurrentPage:
            return {
                ...state,
                currentPage: action.currentPage
            };
        default:
            return state;
    }
};
export default customizationReducer;
